import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Company } from '../interfaces/compani.inteface';
import { Reason } from '../interfaces/reason.interface';

@Injectable({
    providedIn: 'root',
})
export class CompanyService {
    private apiUrl = environment.apiSiriUrl;

    constructor(private http: HttpClient) {}

    async GetCompanies(url: string): Promise<Company[]> {
        const apiUrl = `${this.apiUrl}${url}`;
        try {
            const data = await firstValueFrom(this.http.get<Company[]>(apiUrl));
            return data;
        } catch (error) {
            throw error;
        }
    }

    async PatchCompany(url: string, body?: any) {
        const apiUrl = `${this.apiUrl}${url}`;
        try {
            const data = await firstValueFrom(
                this.http.patch(apiUrl, body ?? {})
            );
            return data;
        } catch (error) {
            throw error;
        }
    }

    /**
     * Trae los motivos de desactivación desde el backend
     *
     * @returns  Promise<Reason[]> Lista de motivos de desactivación
     */
    async getMotivosDesactivacion(): Promise<Reason[]> {
        const url = `${this.apiUrl}agente-vigilado/motivos-inactivacion`;
        try {
            return await firstValueFrom(this.http.get<Reason[]>(url));
        } catch (error) {
            throw this.handleErrorResponse(error);
        }
    }

    private handleErrorResponse(error: HttpErrorResponse) {
        console.error('API Error:', error);
        throw {
            message: error.error?.message || 'Error en la petición',
            status: error.status,
            error: error.error,
        };
    }
}
